// removed by extract-text-webpack-plugin
module.exports = {"loader":"loading__loader___PtmPf","stretchdelay":"loading__stretchdelay___3a7Dw","circle1":"loading__circle1___129S9","circle2":"loading__circle2___9ddCX","circle3":"loading__circle3___1aQxQ","circle4":"loading__circle4___29P_2","fadein":"loading__fadein___iBu7Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/indicators/loading.scss
// module id = 277
// module chunks = 0